//
// GestureRecognizerState.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var GestureRecognizerState = {
    POSSIBLE:0,
    BEGAN:1,
    CHANGED:2,
    ENDED:3,
    CANCELLED:4,
    FAILED:5
};
export default GestureRecognizerState;
